import {
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ContactService } from "../../contact.service";
import { DetailedListContact } from "../../models/detailed-list.model";
import { PaginationDto } from "src/app/core/dto/pagination.dto";
import { debounceTime } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { GetDetailedListRequestDTO } from "../../dtos/detailed-list-request.dto";
import { StatusCliente } from "../../../status-config/model/status.model";
import { StatusConfigService } from "../../../status-config/services/status-config.service";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { DetailedListClientComponent } from "./components/detailed-list-client/detailed-list-client.component";
import { AuthService } from "src/app/core/services/auth/auth.service";
import { ErrorMessagesService } from "src/app/shared/messages/services/error-messages.service";
import { Location } from '@angular/common';

@Component({
  selector: "app-detailed-list",
  templateUrl: "./detailed-list.component.html",
  styleUrl: "./detailed-list.component.scss",
})
export class DetailedListComponent implements OnInit, OnDestroy {
  breadCrumbItems!: Array<{}>;

  // private readonly _destroyed$ = new Subject<void>();
  private readonly destroyedRef = inject(DestroyRef);
  rows: DetailedListContact[] = [];
  pagination: PaginationDto = {
    paginaAtual: 1,
    quantidadePorPagina: 10,
    totalDeItens: 0,
    ultimaPagina: 1,
  };
  error = "";
  isLoading = false;
  form!: FormGroup;
  statusMessages: StatusCliente[] = [];

  //permissoes
  podeEditar = false;
  constructor(
    private route: ActivatedRoute,
    private contactService: ContactService,
    private fb: FormBuilder,
    private statusConfigService: StatusConfigService,
    private offcanvasService: NgbOffcanvas,
    private authService: AuthService,
    private errorMessagesService: ErrorMessagesService,
    private location: Location
  ) {
    this.form = this.fb.group({
      "Paginacao.PaginaAtual": [1],
      "Paginacao.QuantidadePorPagina": [10],
      cliente: [""],
      statusId: [""],
      agendamento: [""],
    });
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Contatos Gerados" },
      { label: "Lista", active: true },
    ];
    
    this.route.params.subscribe((params) => {
      const listId = params["id"];
      this.getDetailedList({
        identificadorLista: listId,
        "Paginacao.PaginaAtual": 1,
      });
    });
    this.statusConfigService
      .getStatusMessages()
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (status) => {
          this.statusMessages = status;
        },
        error: (error) => {
          this.error = this.errorMessagesService.getMessage('ERR_0010');
          console.error(error);
        },
      });

    this.form.valueChanges.pipe(debounceTime(400)).subscribe((filters) => {
      this.getDetailedList({
        identificadorLista: this.route.snapshot.params["id"],
        ...filters,
      });
    });
  }

  onPageChange(page: number) {
    this.getDetailedList({
      identificadorLista: this.route.snapshot.params["id"],
      "Paginacao.PaginaAtual": page,
      "Paginacao.QuantidadePorPagina": this.pagination.quantidadePorPagina,
    });
  }

  getDetailedList(data: GetDetailedListRequestDTO) {
    this.isLoading = true;
    this.contactService
      .getDetailedList({...data,})
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (response) => {
          this.rows = response.contatosGerados;
          this.pagination = response.paginacao;
          this.isLoading = false;
        },
        error: (error) => {

          this.error = this.errorMessagesService.getMessage('ERR_0009');
          this.isLoading = false;
          this.error = "Erro ao buscar lista detalhada";
        },
      });
  }

  ngOnDestroy(): void {
    // this.contactService.clearDetailedList();
  }

  open(contactListClient: DetailedListContact) {
    const offCanvasRef = this.offcanvasService.open(
      DetailedListClientComponent,
      {
        position: "end",
      },
    );
    offCanvasRef.componentInstance.client = contactListClient;
    offCanvasRef.closed.subscribe({
      next: () => {
        this.getDetailedList({
          identificadorLista: this.route.snapshot.params["id"],
          "Paginacao.PaginaAtual": this.pagination.paginaAtual,
        });
      },
    });
  }


  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Contatos_Gerados', 'Editar')
  }

  voltar() {
    this.location.back();
  }
}
